import { Dispatch } from "redux";
import { MainInterface } from "../interfaces/main";

export const setMainData = (data: MainInterface) => {
    return (dispatch: Dispatch) => {
        dispatch({ type: "SET_MAIN", payload: data });
    };
};
